module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C154"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_Contents#id_1004",
      "id": "page_xi"
    }
  }, [_vm._v("Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/12_2__A_Grand_Opportunity__1861_and#page_25"
    }
  }, [_vm._v("1. Black Refugees 1")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/12_2__A_Grand_Opportunity__1861_and#page_26"
    }
  }, [_vm._v("2. Black Refugees 2")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/12_2__A_Grand_Opportunity__1861_and#id_981"
    }
  }, [_vm._v("3. Watch meeting, Dec. 31, 1862, waiting for the hour")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "href": "#/html/13_3__The_Forming_of_Black_Regiment#id_982"
    }
  }, [_vm._v("4. 54th Massachusetts Regiment’s charge on Ft. Wagner")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_4__The_Unequal_Pay_Issue#id_983",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Bounties")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_5__Violence_on_Two_Fronts#id_984",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Public gathering for New York’s first black regiment—the 20th USCT")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_9__After_the_War__A_Different_Ki#id_985",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Grand Review of the Army")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_10__Even_Farther_Away_from_Home#id_986",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Forms of soldier punishment during the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_10__Even_Farther_Away_from_Home#id_987",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Members of a black regiment using down time to for reading classes")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_11__Home_Again#id_988",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. “Be Citizens in Peace”")])]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_4__The_Unequal_Pay_Issue#id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional photographs")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15a1915c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_List_of_Figures.vue
// module id = 78
// module chunks = 0